<mat-dialog-content>
  <rpe-viveros-form [formInput]="viveroGrupoEspecieInput" (onFormChange)="formValueChange($event)" (onStatusFormChange)="formStatusChange($event)"></rpe-viveros-form>
  <div class="action">
    <button (click)="onCancel()" mat-raised-button>
      Cerrar
    </button>
    <button (click)="onAdd()" mat-raised-button>
      Registrar
    </button>
  </div>
</mat-dialog-content>
